import { createTheme } from '@mui/material/styles';
import { getTokens, BRAND_ACCENT } from './tokens';

export function createAppTheme(mode) {
  const tokens = getTokens(mode);
  const theme = createTheme({
    palette: {
      mode,
      primary: { main: BRAND_ACCENT },
      background: { default: tokens.pageBg, paper: tokens.card },
      text: { primary: tokens.text, secondary: tokens.muted },
    },
    typography: {
      fontFamily: "'IBM Plex Sans', sans-serif",
    },
  });
  theme.custom = tokens;
  return theme;
}
